import { Link, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { BASEURL } from '../../constants';
import { DoubleRightArrows, PageGroupIcon, TestIcon } from '../Icons/icons';

const CourseDetails = () => {

    const [hierarchy, setHierarchy] = useState(null);
    console.log("Hierarchy " , hierarchy)
    const [courseInfo, setCourseInfo] = useState(null);
    const { courseId, sharedCourseId } = useParams();
    const [courseImage, setCourseImage] = useState("");
    const [completionPercentage , setCompletionPercentage] = useState(0);

    const navigate = useNavigate();

    useEffect(() => {
        axios.post(`${BASEURL}/api/update-course-completion-percentage`, {
            courseId: sharedCourseId,
            masterCourseId: courseId,
        }).then((response) => {
            console.log("response", response);
            //increase the completion bar 
        })
    }, [])

    
    useEffect(() => {
        const fetchCourseCompletionPercentage = async () => {
            // what could go wrong
            const response = await axios.get(`${BASEURL}/api/get-course-completion-percentage` , {
                params:{
                    courseId: sharedCourseId
                }
            })
            console.log(response)
            setCompletionPercentage(response.data[0].course_completion_percentage);
            console.log("percentage respnse " , response);
        } 

        fetchCourseCompletionPercentage();
    } , [])

    useEffect(() => {
        const fetchSidebarHierarchy = axios.get(`${BASEURL}/api/get-sidebar-hierarchy`, {
            params: {
                courseId: courseId,
            },
        })

        fetchSidebarHierarchy.then((response) => {

            axios.get(`${BASEURL}/api/fetch-course-info`, {
                params: {
                    courseId: courseId,
                },
            }).then((res) => {
                console.log("course info ", res)

                const fetchedSidebarData = response.data;

                if (fetchedSidebarData.topics.length) {
                    console.log("fetchedSidebarData", fetchedSidebarData)
                    setHierarchy(fetchedSidebarData);
                } else {
                    setHierarchy({ topics: [] })
                }
                console.log("cousreinfo ", res.data.rows)
                setCourseInfo(res.data.rows)

                axios.post(`${BASEURL}/api/retrieve-cover-image`, { courseId: courseId }).then((imageResponse) => {
                    console.log("image response ", imageResponse);
                    setCourseImage(imageResponse.data.dataUrl)
                })
            })
        })
    }, [])

    function truncateText(text , charecterLimit){

        if(text.length < charecterLimit){
            return text
        }
    
        let truncatedText = text.slice(0 , charecterLimit);
    
        return truncatedText.concat('...');
        // kkfk fkkdk kkdkf kdf dkfkskkakfk kaksdkf kskdkf ksdk fkaksdk fkskd fkskd ...
    }

    return (
        courseInfo ? (
            <div className="h-dvh w-full box-border flex flex-col gap-4 p-6">
                <div className='flex gap-5 items-center'>
                    <button className='inline-flex truncate justify-center items-center rounded-md bg-gray-200 p-2 text-xs font-semibold text-black shadow-sm hover:bg-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ' 
                    onClick={() => { navigate('/student/myCourses/all') }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mx-1">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                    </button>
                    {/* <span className='font-bold text-lg'>{courseInfo ? courseInfo.course_name : 'Know Basics of Noun'}</span> */}
                </div>
                {/* course detail card */}
                <div className='w-full h-56 bg-white shrink-0 p-4 flex gap-4'>
                    <div className='w-48 flex items-center justify-center h-full shrink-0 border border-gray-200 p-2'>
                        {
                            courseImage && <img className='object-cover' src={courseImage} />
                        }
                    </div>
                    <div className='flex flex-col grow gap-2'>
                        <div className='text-slate-400 text-sm'>
                            A course by {courseInfo ? courseInfo.creator_name : ''}
                        </div>
                        <div className='font-bold text-2xl truncate'>
                            {courseInfo ? courseInfo.course_name : ''}
                        </div>
                        <div>
                            {
                                courseInfo ? truncateText(courseInfo.course_desc, 80) : 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Adipisci sapiente magni porro blanditiis nam qui deleniti architecto non illum, explicabo vitae, mollitia minima nobis atque? Labore modi eligendi optio debitis.'
                            }
                        </div>
                        <div>
                            <div className='h-2 w-full rounded-full bg-gray-200'>
                                <div className='h-2 rounded-full bg-[#F2994A]' style={completionPercentage ? { width : `${completionPercentage}%`}:{ width : '0%'} }></div>
                            </div>
                        </div>
                        <div className='flex justify-between'>
                            <div className='text-sm text-slate-400'><span>{completionPercentage ? `${completionPercentage}%`:`0%`}</span> Complete</div>
                            <div className='text-slate-400 text-sm'>4/30 Topics</div>
                        </div>
                        <div className='flex justify-between'>
                            <div className='flex gap-2'>
                                {
                                    courseInfo && courseInfo.tags.map((tag) => {
                                        return <div className='border p-2 text-xs'>{tag}</div>
                                    })
                                }
                            </div>
                            <div>
                                <Link to={`/CourseConsumption/${courseId}/${sharedCourseId}`} >
                                    <button className='p-2 text-white bg-customPrimaryPurple text-sm'>Start Learning</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=''>
                    <h3 className='font-bold text-lg'>Course Curriculum</h3>
                </div>
                <div className='flex gap-4 w-max px-8 p-4 bg-white border border-gray-400'>
                    <div className='flex items-center gap-4'>
                        <div className='p-2 rounded-full bg-[#F2994A26]'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <g clip-path="url(#clip0_631_23384)">
                                    <path d="M16.088 6.91194C15.7435 6.46723 15.2747 6.13484 14.741 5.95694L13.363 5.50894C13.2572 5.47128 13.1657 5.40181 13.1009 5.31005C13.0362 5.21829 13.0014 5.10874 13.0014 4.99644C13.0014 4.88414 13.0362 4.7746 13.1009 4.68284C13.1657 4.59108 13.2572 4.5216 13.363 4.48394L14.741 4.03594C15.1488 3.89513 15.5191 3.66327 15.8239 3.35797C16.1287 3.05267 16.3599 2.68195 16.5 2.27394L16.511 2.23994L16.959 0.862942C16.9962 0.756456 17.0657 0.664182 17.1577 0.598894C17.2497 0.533607 17.3597 0.498535 17.4725 0.498535C17.5853 0.498535 17.6953 0.533607 17.7873 0.598894C17.8793 0.664182 17.9488 0.756456 17.986 0.862942L18.433 2.23994C18.5727 2.65848 18.8081 3.03871 19.1203 3.35046C19.4326 3.66221 19.8132 3.89691 20.232 4.03594L21.609 4.48394L21.637 4.49094C21.7428 4.5286 21.8343 4.59808 21.8991 4.68984C21.9638 4.7816 21.9986 4.89114 21.9986 5.00344C21.9986 5.11574 21.9638 5.22529 21.8991 5.31705C21.8343 5.40881 21.7428 5.47828 21.637 5.51594L20.259 5.96394C19.8404 6.10311 19.46 6.33786 19.1479 6.64961C18.8358 6.96135 18.6006 7.34151 18.461 7.75994L18.013 9.13694L18 9.17094C17.9568 9.27157 17.8842 9.35681 17.7918 9.41552C17.6993 9.47423 17.5913 9.50367 17.4819 9.5C17.3724 9.49632 17.2666 9.4597 17.1784 9.39493C17.0901 9.33015 17.0234 9.24024 16.987 9.13694L16.539 7.75994C16.4389 7.45348 16.2867 7.16659 16.089 6.91194M23.784 10.7129L23.018 10.4649C22.7856 10.3872 22.5744 10.2565 22.4012 10.0831C22.228 9.90975 22.0975 9.69845 22.02 9.46594L21.77 8.70194C21.7493 8.64287 21.7107 8.5917 21.6597 8.55549C21.6086 8.51929 21.5476 8.49984 21.485 8.49984C21.4224 8.49984 21.3614 8.51929 21.3103 8.55549C21.2593 8.5917 21.2207 8.64287 21.2 8.70194L20.952 9.46594C20.8759 9.69696 20.7476 9.9073 20.5769 10.0806C20.4062 10.2539 20.1978 10.3854 19.968 10.4649L19.203 10.7129C19.1439 10.7336 19.0928 10.7722 19.0565 10.8232C19.0203 10.8743 19.0009 10.9354 19.0009 10.9979C19.0009 11.0605 19.0203 11.1216 19.0565 11.1726C19.0928 11.2237 19.1439 11.2622 19.203 11.2829L19.968 11.5319C20.2011 11.6097 20.4129 11.7407 20.5865 11.9147C20.7601 12.0886 20.8907 12.3007 20.968 12.5339L21.216 13.2979C21.2367 13.357 21.2753 13.4082 21.3263 13.4444C21.3774 13.4806 21.4384 13.5 21.501 13.5C21.5636 13.5 21.6246 13.4806 21.6757 13.4444C21.7267 13.4082 21.7653 13.357 21.786 13.2979L22.035 12.5339C22.1126 12.3013 22.2432 12.09 22.4166 11.9166C22.59 11.7432 22.8014 11.6125 23.034 11.5349L23.799 11.2869C23.8581 11.2662 23.9092 11.2277 23.9454 11.1766C23.9817 11.1256 24.0011 11.0645 24.0011 11.0019C24.0011 10.9394 23.9817 10.8783 23.9454 10.8272C23.9092 10.7762 23.8581 10.7376 23.799 10.7169L23.784 10.7129ZM12.072 4.49994H4.75C4.02065 4.49994 3.32118 4.78967 2.80546 5.3054C2.28973 5.82112 2 6.5206 2 7.24994V17.7499C2 18.1111 2.07113 18.4687 2.20933 18.8023C2.34753 19.136 2.5501 19.4391 2.80546 19.6945C3.06082 19.9498 3.36398 20.1524 3.69762 20.2906C4.03127 20.4288 4.38886 20.4999 4.75 20.4999H19.25C19.6111 20.4999 19.9687 20.4288 20.3024 20.2906C20.636 20.1524 20.9392 19.9498 21.1945 19.6945C21.4499 19.4391 21.6525 19.136 21.7907 18.8023C21.9289 18.4687 22 18.1111 22 17.7499V14.4309C21.75 14.5467 21.4694 14.5793 21.1995 14.524C20.9296 14.4688 20.6845 14.3286 20.5 14.1239V17.7499C20.5 18.4399 19.94 18.9999 19.25 18.9999H4.75C4.06 18.9999 3.5 18.4399 3.5 17.7499V7.24994C3.5 6.55994 4.06 5.99994 4.75 5.99994H12.373C12.34 5.95427 12.309 5.90723 12.28 5.85894C12.1445 5.66304 12.0554 5.43887 12.0193 5.20342C11.9833 4.96797 12.0013 4.7274 12.072 4.49994ZM6 9.24994C6 9.05103 6.07902 8.86026 6.21967 8.71961C6.36032 8.57896 6.55109 8.49994 6.75 8.49994H11.25C11.4489 8.49994 11.6397 8.57896 11.7803 8.71961C11.921 8.86026 12 9.05103 12 9.24994C12 9.44885 11.921 9.63962 11.7803 9.78027C11.6397 9.92092 11.4489 9.99994 11.25 9.99994H6.75C6.55109 9.99994 6.36032 9.92092 6.21967 9.78027C6.07902 9.63962 6 9.44885 6 9.24994ZM6.75 11.4999C6.55109 11.4999 6.36032 11.579 6.21967 11.7196C6.07902 11.8603 6 12.051 6 12.2499C6 12.4489 6.07902 12.6396 6.21967 12.7803C6.36032 12.9209 6.55109 12.9999 6.75 12.9999H15.25C15.4489 12.9999 15.6397 12.9209 15.7803 12.7803C15.921 12.6396 16 12.4489 16 12.2499C16 12.051 15.921 11.8603 15.7803 11.7196C15.6397 11.579 15.4489 11.4999 15.25 11.4999H6.75ZM6 15.2499C6 15.051 6.07902 14.8603 6.21967 14.7196C6.36032 14.579 6.55109 14.4999 6.75 14.4999H13.25C13.4489 14.4999 13.6397 14.579 13.7803 14.7196C13.921 14.8603 14 15.051 14 15.2499C14 15.4489 13.921 15.6396 13.7803 15.7803C13.6397 15.9209 13.4489 15.9999 13.25 15.9999H6.75C6.55109 15.9999 6.36032 15.9209 6.21967 15.7803C6.07902 15.6396 6 15.4489 6 15.2499Z" fill="#F2994A" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_631_23384">
                                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <span className='flex flex-col '>
                            <span className='font-bold'>{courseInfo ? courseInfo.slide_count : '60'}</span>
                            <span className='text-sm'>Slides</span>
                        </span>
                    </div>
                    <div className='h-full w-[2px] bg-gray-200'>

                    </div>
                    <div className='flex items-center gap-4'>
                        <div className='p-2 rounded-full bg-[#F2994A26]'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                                <circle cx="11" cy="11.5" r="10" stroke="#F2994A" stroke-width="1.5" />
                                <path d="M14.4531 11.8948C14.3016 12.5215 13.5857 12.9644 12.1539 13.8502C10.7697 14.7064 10.0777 15.1346 9.51993 14.9625C9.28934 14.8913 9.07925 14.7562 8.90982 14.57C8.5 14.1198 8.5 13.2465 8.5 11.5C8.5 9.75345 8.5 8.88018 8.90982 8.42995C9.07925 8.24381 9.28934 8.10868 9.51993 8.03753C10.0777 7.86544 10.7697 8.29357 12.1539 9.14983C13.5857 10.0356 14.3016 10.4785 14.4531 11.1052C14.5156 11.3639 14.5156 11.6361 14.4531 11.8948Z" stroke="#F2994A" stroke-width="1.5" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <span className='flex flex-col '>
                            <span className='font-bold'>{courseInfo ? courseInfo.video_count : '60'}</span>
                            <span className='text-sm'>Vidoes</span>
                        </span>
                    </div>
                    <div className='h-full w-[2px] bg-gray-200'>

                    </div>
                    <div className='flex items-center gap-4'>
                        <div className='p-2 rounded-full bg-[#F2994A26]'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                                <path d="M21 11.0667C21 16.3499 16.5222 20.6334 11 20.6334C10.3507 20.6343 9.70324 20.5742 9.06542 20.4545C8.60633 20.3682 8.37678 20.3251 8.21653 20.3496C8.05627 20.3741 7.82918 20.4948 7.37499 20.7364C6.09014 21.4197 4.59195 21.661 3.15111 21.393C3.69874 20.7194 4.07275 19.9112 4.23778 19.0448C4.33778 18.5148 4.09 18 3.71889 17.6231C2.03333 15.9115 1 13.6051 1 11.0667C1 5.78357 5.47778 1.5 11 1.5C16.5222 1.5 21 5.78357 21 11.0667Z" stroke="#F2994A" stroke-width="1.5" stroke-linejoin="round" />
                                <path d="M9 9.34615C9 8.32655 9.89543 7.5 11 7.5C12.1046 7.5 13 8.32655 13 9.34615C13 9.71368 12.8837 10.0561 12.6831 10.3438C12.0854 11.2012 11 12.0189 11 13.0385V13.5" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M11 16H11.009" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <span className='flex flex-col '>
                            <span className='font-bold'>{courseInfo ? courseInfo.quiz_count : '60'}</span>
                            <span className='text-sm'>Quiz</span>
                        </span>
                    </div>
                    <div className='h-full w-[2px] bg-gray-200'>

                    </div>
                    <div className='flex items-center gap-4'>
                        <div className='p-2 rounded-full bg-[#F2994A26]'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path d="M3.375 11V16.4375C3.375 18.9228 5.38973 20.9375 7.875 20.9375H13.3125" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M15.9375 3.875H10.6875C8.20222 3.875 6.1875 5.88972 6.1875 8.375V13.625C6.1875 16.1103 8.20222 18.125 10.6875 18.125H15.9375C18.4228 18.125 20.4375 16.1103 20.4375 13.625V8.375C20.4375 5.88972 18.4228 3.875 15.9375 3.875Z" stroke="#F2994A" stroke-width="1.5" />
                                <path d="M13.2188 11.2812V11.1476C13.2188 10.7657 13.4209 10.4124 13.75 10.2187C14.4083 9.83152 14.8906 9.10843 14.6962 8.36983C14.5324 7.7471 14.1419 7.25 13.2188 7.25C11.7188 7.25 11.625 8.375 11.625 9.03125" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M13.3125 14.75C13.8303 14.75 14.25 14.3303 14.25 13.8125C14.25 13.2947 13.8303 12.875 13.3125 12.875C12.7947 12.875 12.375 13.2947 12.375 13.8125C12.375 14.3303 12.7947 14.75 13.3125 14.75Z" fill="#F2994A" />
                            </svg>
                        </div>
                        <span className='flex flex-col '>
                            <span className='font-bold'>{courseInfo ? courseInfo.test_count : '60'}</span>
                            <span className='text-sm'>Test</span>
                        </span>
                    </div>
                </div>

                <div className='flex flex-col gap-4 justify-start'>
                    {
                        hierarchy && (
                            hierarchy.topics.map((topic, index) => {
                                return (
                                    <div key={index} className='w-full bg-white' >
                                        <div onClick={(event) => {
                                            const targetElement = event.currentTarget;
                                            const dropdown = targetElement.nextElementSibling;
                                            console.log("dropdown.style.width"  ,dropdown.style.height )
                                            if (!dropdown.style.height || dropdown.style.height === '0px' ) {
                                                dropdown.style.height = `${dropdown.scrollHeight}px`;
                                                targetElement.children[0].style.transform = `rotate(90deg)`; 
                                            } else {
                                                dropdown.style.height = '0px';
                                                targetElement.children[0].style.transform = `rotate(0deg)`; 
                                            }
                                        }} className='px-6 py-4 flex items-center gap-4 cursor-pointer'>
                                            <div className='transition-all duration-300'>
                                                <DoubleRightArrows />
                                            </div>
                                            <div className='font-bold text-base text-[#333]'>
                                                {`${topic.name}`}
                                            </div>
                                        </div>
                                        <div className='h-0 overflow-hidden transition-all duration-300 border border-borderColor'>
                                            {topic.content.map((contentObj) => {
                                                return (
                                                    <div className='flex p-4 items-center gap-2 border-t border-borderColor'>
                                                        <div className=''>
                                                            {
                                                                contentObj.type === 'slide-group' && <PageGroupIcon />
                                                            }
                                                            {
                                                                contentObj.type === 'test' && <TestIcon />
                                                            }
                                                        </div>
                                                        <div className='text-bold'>{contentObj.name}</div>
                                                        <div></div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })
                        )
                    }
                </div>
            </div>
        ) : (
            <div>
                fetching course details...
            </div>
        )

    )
}

export default CourseDetails;